var r=Array.isArray;export{r as i};
//# sourceMappingURL=isArray.js.map
